(function () {
  var CARD_BG = '#f6f6f6';

  function styleImage(img) {
    img.style.setProperty('mix-blend-mode', 'multiply', 'important');
    img.style.setProperty('object-fit', 'contain', 'important');
    img.style.setProperty('object-position', 'center', 'important');
    img.style.setProperty('width', '100%', 'important');
    img.style.setProperty('height', '100%', 'important');
    img.style.setProperty('position', 'absolute', 'important');
    img.style.setProperty('inset', '0', 'important');
    img.style.setProperty('aspect-ratio', 'unset', 'important');
    img.style.setProperty('margin', '0', 'important');
  }

  function processCard(card) {
    if (card.dataset.srDone) return;
    card.dataset.srDone = 'true';

    card.style.setProperty('background-color', CARD_BG, 'important');
    card.style.setProperty('aspect-ratio', '3 / 4', 'important');
    card.style.setProperty('display', 'block', 'important');
    card.style.setProperty('position', 'relative', 'important');
    card.style.setProperty('overflow', 'hidden', 'important');

    var primary = card.querySelector('.product-card__image--primary');
    if (!primary) return;

    // Apply immediately regardless of load state
    styleImage(primary);

    // Re-apply after load in case browser resets styles on image decode
    if (!primary.complete || primary.naturalWidth === 0) {
      primary.addEventListener('load', function () {
        styleImage(primary);
      }, { once: true });
    }
  }

  function processAll() {
    document.querySelectorAll('.product-card__media.custom-background').forEach(function(card) {
      processCard(card);
    });
  }

  processAll();
  document.addEventListener('DOMContentLoaded', processAll);
  window.addEventListener('load', processAll);

  // Re-run every 500ms for 5 seconds after load to catch carousel lazy cards
  var runs = 0;
  var interval = setInterval(function () {
    processAll();
    runs++;
    if (runs >= 10) clearInterval(interval);
  }, 500);

  var observer = new MutationObserver(function () { processAll(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
